import React from 'react';
import { getValidAccessToken, startLogin } from '../../utils/oidc';
import { USER_TOKEN_KEY } from '../../utils/authTokens';

// Портал авторизации (SSR-страницы amazing_auth)
const AUTH_PORTAL = process.env.REACT_APP_AUTH_URL ?? 'http://localhost:3002';

/**
 * Ведёт пользователя со статусом `steam_unlinked` на SSR-страницу привязки
 * Steam (amazing_auth). Получает одноразовый ticket по Bearer-токену (чтобы не
 * передавать access-токен в URL) и редиректит на /account/link-steam.
 */
const SteamLinkRedirect: React.FC = () => {
  React.useEffect(() => {
    void (async () => {
      let token = await getValidAccessToken();
      if (!token) token = localStorage.getItem(USER_TOKEN_KEY);
      if (!token) { await startLogin('/panel'); return; }

      try {
        const res = await fetch(`${AUTH_PORTAL}/auth/steam/start`, {
          method: 'POST',
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = (await res.json().catch(() => ({}))) as { ticket?: string };
        const qs = data.ticket ? `?ticket=${encodeURIComponent(data.ticket)}` : '';
        window.location.replace(`${AUTH_PORTAL}/account/link-steam${qs}`);
      } catch {
        window.location.replace(`${AUTH_PORTAL}/account/link-steam`);
      }
    })();
  }, []);

  return (
    <div style={{
      display: 'flex', justifyContent: 'center', alignItems: 'center',
      minHeight: '100vh', background: '#0d0d1a', color: 'rgba(255,255,255,0.7)', fontSize: 14,
    }}>Перенаправление…</div>
  );
};

export default SteamLinkRedirect;
